module.exports = __webpack_public_path__ + "img/dots-g.771fd20d.svg";